import { UseFormReturn } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from '@/components/ui/form'
import { RichTextEditor } from '@/components/ui/rich-text-editor'
import type { ObjectFormData } from '../schema'

interface RecoveryInformationTabProps {
    form: UseFormReturn<ObjectFormData>
}

export function RecoveryInformationTab({ form }: RecoveryInformationTabProps) {
    const { t } = useTranslation()

    return (
        <div className="space-y-4">
            <FormField
                control={form.control}
                name="Instructions"
                render={({ field }) => (
                    <FormItem>
                        <FormLabel>{t('objects.recoveryInformation')}</FormLabel>
                        <FormControl>
                            <RichTextEditor
                                value={field.value || ''}
                                onChange={field.onChange}
                                placeholder={t('objects.recoveryInformationPlaceholder')}
                            />
                        </FormControl>
                        <FormMessage />
                    </FormItem>
                )}
            />
            <p className="text-sm text-muted-foreground">
                {t('objects.recoveryInformationDescription')}
            </p>
        </div>
    )
}
